import React, { useState } from 'react';
import { Typography } from '@material-ui/core';
import { ConfigFieldControl, ConfigTextField, PageTemplate, PageTemplateCardOver, PageTemplateHeader, PageTemplateHeaderActions } from '@sierralabs/core-ui';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteContext } from '../../SiteContext';
import { SlotRenderer } from '../renderers';
import { SiteComponent } from '../SiteComponentPlugin';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
export const SiteTablePage = props => {
    var _a;
    const { children } = props;
    const component = useSubscribeComponentChanges(SiteTablePagePlugin, props);
    const { editing } = useSiteContext();
    const [openDialog, setOpenDialog] = useState(false);
    // console.log('route', path || component?.props?.path, component);
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteTablePagePlugin }, props),
        React.createElement(PageTemplate, null,
            React.createElement(PageTemplateHeader, null,
                React.createElement(Typography, { variant: 'h2' }, (_a = component.props) === null || _a === void 0 ? void 0 : _a.heading),
                React.createElement(PageTemplateHeaderActions, { flex: true },
                    React.createElement(SlotRenderer, { component: component, slot: 'header-actions' }))),
            React.createElement(PageTemplateCardOver, null,
                React.createElement(SlotRenderer, { component: component, slot: 'table' })))));
};
export const SiteTablePageConfigurator = ({ component }) => {
    var _a, _b;
    const { update, updateSlot } = useConfigComponent(component);
    const slotComponent = (_a = component.children) === null || _a === void 0 ? void 0 : _a.find(c => c.slot === 'route');
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(ConfigTextField, { fullWidth: true, label: 'Heading', value: ((_b = component.props) === null || _b === void 0 ? void 0 : _b.heading) || '', onChange: event => {
                    update('props.heading', event.target.value);
                } }))));
};
export const SiteTablePagePlugin = {
    name: 'Site Table Page',
    type: 'site-table-page',
    component: SiteTablePage,
    configurator: SiteTablePageConfigurator,
    slots: [
        {
            name: 'Header Actions',
            type: 'component-stack',
            slot: 'header-actions'
        },
        {
            name: 'Table',
            type: 'table',
            slot: 'table'
        }
    ]
};
//# sourceMappingURL=SiteTablePagePlugin.js.map